import { useSearchParams } from 'react-router-dom';

export function useDatasetLayoutIdParam() {
  const [searchParams] = useSearchParams();
  return searchParams.get('DatasetLayoutId');
}
